import { FieldDataTypeEnum } from 'ui-component/records/types';

export const STRING_LIKE_DATA_TYPES_TO_FILTER = ['string', 'textarea', 'url', 'object', 'phone', 'email'] as const;

export const isStringLikeDatatype = (dataType: FieldDataTypeEnum) =>
    STRING_LIKE_DATA_TYPES_TO_FILTER.includes(dataType as (typeof STRING_LIKE_DATA_TYPES_TO_FILTER)[number]);
